<template>
  <footer
    class="site-footer"
    v-if="showFooter || dirPage"
    style="position: relative; z-index: 100"
  >
    <CookieLaw
      buttonClass="btn btn-sm btn-primary cookie-law-button"
      theme="black"
    ></CookieLaw>

    <div class="footer-content-grid">
      <!-- Column 1: Cabo Navigation -->
      <div class="footer-column">
        <h5 class="footer-section-header" :style="{ color: footerAccentColor }">
          LOS CABOS
        </h5>
        <ul class="footer-nav-list">
          <li class="nav-item">
            <router-link :to="{ path: '/#event-line' }">Event Line</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-events-today' }"
              >Today</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-clubs' }"
              >Nightclubs</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-mexico-event-calendar' }"
              >Party Calendar</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-dinner-table-reservations' }"
              >Dinner & Show</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-dj-schedule' }"
              >DJ Schedule</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-nightlife' }"
              >Nightlife Guide</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/reservations' }"
              >Table Reservations</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/concierge-services' }"
              >Concierge Services</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/cabo-nye-2025' }"
              >New Year Celebration</router-link
            >
          </li>
        </ul>
      </div>

      <!-- Column 2: Top Clubs -->
      <div class="footer-column">
        <h5 class="footer-section-header" :style="{ color: footerAccentColor }">
          TOP CLUBS
        </h5>
        <ul class="footer-nav-list">
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-clubs/mandala-los-cabos' }"
              >Mandala</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-clubs/crania-los-cabos' }"
              >Crania</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-clubs/bagatelle-los-cabos' }"
              >Bagatelle</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-clubs/taboo-los-cabos' }"
              >Taboo</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              :to="{ path: '/los-cabos-clubs/el-squid-roe-los-cabos' }"
              >El Squid Roe</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-clubs/rosa-negra-los-cabos' }"
              >Rosa Negra</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-clubs/chambao-los-cabos' }"
              >Chambao</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-clubs/la-vaquita-los-cabos' }"
              >La Vaquita</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-clubs/riu-party-los-cabos' }"
              >Riu Party</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-clubs/amante-los-cabos' }"
              >Amante Speakeasy</router-link
            >
          </li>
        </ul>
      </div>

      <!-- Column 3: Dining & Experiences -->
      <div class="footer-column">
        <h5 class="footer-section-header" :style="{ color: footerAccentColor }">
          DINING & LOUNGES
        </h5>
        <ul class="footer-nav-list">
          <li class="nav-item">
            <router-link
              :to="{ path: '/los-cabos-clubs/ilios-restaurant-los-cabos' }"
              >Ilios Greek</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-clubs/mamazzita-los-cabos' }"
              >Mamazzita</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              :to="{ path: '/los-cabos-clubs/funky-geisha-los-cabos' }"
              >Funky Geisha</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-clubs/craft-los-cabos' }"
              >Craft Open Fire</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-clubs/harrys-los-cabos' }"
              >Harry's Prime</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              :to="{ path: '/los-cabos-clubs/tamara-beach-club-los-cabos' }"
              >Tamara</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              :to="{ path: '/los-cabos-clubs/veleros-beach-club-los-cabos' }"
              >Veleros Beach</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              :to="{ path: '/los-cabos-clubs/crush-nightspot-los-cabos' }"
              >Crush Nightspot</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              :to="{ path: '/los-cabos-clubs/the-nowhere-bar-los-cabos' }"
              >The Nowhere Bar</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              :to="{ path: '/los-cabos-clubs/campomar-restaurant-los-cabos' }"
              >Campomar</router-link
            >
          </li>
        </ul>
      </div>

      <!-- Column 4: Resources -->
      <div class="footer-column">
        <h5 class="footer-section-header" :style="{ color: footerAccentColor }">
          RESOURCES
        </h5>
        <ul class="footer-nav-list">
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-events-today' }"
              >Cabo Today</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/los-cabos-dj-schedule' }"
              >DJ Schedule</router-link
            >
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/article' }">Blog</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/faq' }">FAQS</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ path: '/about' }">About Us</router-link>
          </li>
          <li class="nav-item">
            <a
              href="https://wa.me/524421177251"
              target="_blank"
              rel="noopener noreferrer"
              >WhatsApp Concierge</a
            >
          </li>
          <li class="nav-item">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://imgix.cosmicjs.com/b71976d0-e281-11eb-b4d6-4f771ba4265e-TulumPartyAviso-Privacidad.pdf"
            >
              Aviso Privacidad
            </a>
          </li>
        </ul>
      </div>

      <!-- Column 5: Other Destinations -->
      <div class="footer-column">
        <h5 class="footer-section-header" :style="{ color: footerAccentColor }">
          DESTINATIONS
        </h5>
        <ul class="footer-nav-list">
          <li class="nav-item">
            <router-link :to="{ path: '/' }"
              ><strong>LOS CABOS</strong></router-link
            >
          </li>
          <li class="nav-item">
            <a
              href="https://tulum.party"
              target="_blank"
              rel="noopener noreferrer"
              >TULUM</a
            >
          </li>
          <li class="nav-item">
            <a
              href="https://tulum.party/cancun"
              target="_blank"
              rel="noopener noreferrer"
              >CANCUN</a
            >
          </li>
          <li class="nav-item">
            <a
              href="https://tulum.party/playa-del-carmen"
              target="_blank"
              rel="noopener noreferrer"
              >PLAYA DEL CARMEN</a
            >
          </li>
          <li class="nav-item">
            <a
              href="https://tulum.party/cdmx-events"
              target="_blank"
              rel="noopener noreferrer"
              >CDMX</a
            >
          </li>
          <li class="nav-item">
            <a
              href="https://tulum.party/riviera-maya"
              target="_blank"
              rel="noopener noreferrer"
              >RIVIERA MAYA</a
            >
          </li>
        </ul>
      </div>
    </div>

    <!-- Professional Footer Bottom -->
    <div
      class="footer-bottom"
      :style="{
        background: footerBgGradient,
        borderImage: footerBorderGradient ? `${footerBorderGradient} 1` : null,
        borderImageSlice: footerBorderGradient ? '1' : null,
        borderTop: footerBorderGradient
          ? '2px solid'
          : '1px solid rgba(255, 255, 255, 0.05)',
      }"
    >
      <div class="footer-bottom-container">
        <!-- Brand & Legal -->
        <div class="footer-brand-section">
          <div class="brand-name" :style="{ color: footerAccentColor }">
            cabo.party
          </div>
          <div class="legal-marks">
            <span class="trademark">MARCA REGISTRADA®</span>
            <span class="separator">•</span>
            <span class="origin">HECHO EN MÉXICO</span>
          </div>
        </div>

        <!-- Copyright -->
        <div class="footer-copyright">
          <p>© {{ currentYear }} cabo.party. All rights reserved.</p>
        </div>

        <!-- Social Links -->
        <div class="footer-social">
          <a
            href="https://wa.me/524421177251"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
          >
            <img v-lazy="whatsappIcon" alt="WhatsApp" />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex';
import CookieLaw from 'vue-cookie-law';

export default {
  name: 'ContentFooter',
  components: {
    CookieLaw,
  },
  props: {
    dirPage: {
      type: Boolean,
      default: false,
    },
    primaryColor: {
      type: String,
      default: '#ff8d72',
    },
    secondaryColor: {
      type: String,
      default: '#da3b9c',
    },
  },
  data() {
    return {
      instagramIcon:
        'https://imgix.cosmicjs.com/6d099b90-5c09-11ec-a8a3-53f360c99be6-instagram.png',
      whatsappIcon:
        'https://imgix.cosmicjs.com/aee48440-99eb-11ee-bdf1-7fea048bb7c9-favicon.png',
    };
  },
  computed: {
    ...mapState({
      showFooter: (state) => state.showFooter !== false,
    }),
    currentYear() {
      return new Date().getFullYear();
    },
    footerAccentColor() {
      return this.primaryColor || '#ff8d72';
    },
    footerBgGradient() {
      if (this.primaryColor && this.secondaryColor) {
        return `linear-gradient(180deg, ${this.primaryColor}15 0%, ${this.secondaryColor}15 100%)`;
      }
      return 'linear-gradient(180deg, rgba(20, 20, 20, 0.95) 0%, rgba(10, 10, 10, 0.98) 100%)';
    },
    footerBorderGradient() {
      if (this.primaryColor && this.secondaryColor) {
        return `linear-gradient(90deg, ${this.primaryColor} 0%, ${this.secondaryColor} 100%)`;
      }
      return null;
    },
  },
};
</script>

<style scoped lang="scss">
.site-footer {
  background: #111112;
  color: #a0a0a5;
  font-family: 'Poppins', sans-serif;
  padding-top: 3rem;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.footer-content-grid {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 2rem;

  @media (max-width: 992px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
}

.footer-section-header {
  font-family: 'Poppins', sans-serif;
  font-size: 1.1rem;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin-bottom: 1.25rem;
  font-weight: 600;
}

.footer-nav-list {
  list-style: none;
  padding: 0;
  margin: 0;

  .nav-item {
    margin-bottom: 0.6rem;

    a {
      color: #888890;
      text-decoration: none;
      font-size: 0.82rem;
      transition: color 0.2s ease, transform 0.2s ease;
      display: inline-block;

      &:hover {
        color: #ffffff;
        transform: translateX(3px);
      }
    }
  }
}

/* Professional Footer Bottom Section */
.footer-bottom {
  background: linear-gradient(
    180deg,
    rgba(20, 20, 20, 0.95) 0%,
    rgba(10, 10, 10, 0.98) 100%
  );
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  position: relative;
  z-index: 100;
  padding: 2.5rem 0;
  margin-top: 3rem;
}

.footer-bottom-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 1.5rem;
  }
}

/* Brand & Legal Section */
.footer-brand-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (max-width: 768px) {
    align-items: center;
  }
}

.brand-name {
  font-family: 'Poppins', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.legal-marks {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-family: 'Poppins', sans-serif;
  font-size: 0.7rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: rgba(255, 255, 255, 0.6);

  @media (max-width: 768px) {
    justify-content: center;
  }
}

.trademark,
.origin {
  transition: color 0.3s ease;

  &:hover {
    color: rgba(255, 255, 255, 0.9);
  }
}

.separator {
  color: rgba(255, 255, 255, 0.3);
  font-size: 0.6rem;
}

/* Copyright Section */
.footer-copyright {
  text-align: center;

  p {
    margin: 0;
    font-family: 'Poppins', sans-serif;
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.5);
    font-weight: 400;
    letter-spacing: 0.3px;
  }
}

/* Social Links */
.footer-social {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;

  @media (max-width: 768px) {
    justify-content: center;
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    transition: all 0.3s ease;
    backdrop-filter: blur(5px);

    img {
      width: 20px;
      height: 20px;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.15);
      border-color: rgba(255, 255, 255, 0.3);
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }
  }
}

@media (max-width: 992px) {
  .footer-bottom {
    padding: 2rem 0;
  }

  .brand-name {
    font-size: 1.3rem;
  }

  .legal-marks {
    font-size: 0.65rem;
  }
}

@media (max-width: 576px) {
  .footer-bottom {
    padding: 1.5rem 0;
  }

  .footer-bottom-container {
    padding: 0 1rem;
  }

  .brand-name {
    font-size: 1.2rem;
  }

  .legal-marks {
    font-size: 0.6rem;
    gap: 0.5rem;
    flex-wrap: wrap;
  }

  .footer-copyright p {
    font-size: 0.75rem;
  }

  .footer-social a {
    width: 36px;
    height: 36px;
  }
}
</style>
